export const installVideo = () => {
  const video = document.querySelector('.video-wrap video');
  const trigger = document.getElementById('video-trigger');

  // Check if video or trigger elements exist
  if (!video || !trigger) {
    console.error('Video element or trigger element is missing.');
    return;
  }

  trigger.addEventListener('click', () => {
    if (video.paused) {
      video.play();
      trigger.textContent = 'PAUSE';
    } else {
      video.pause();
      trigger.textContent = 'PLAY';
    }
  });
};
